'use strict'

var BemCarouselSlider = require('./BemCarouselSlider')
var Hammer = require('hammerjs')

var DEFAULTS = {
	// Sliding animation easing function (supports any jquery names)
	slideEasing: 'swing',
	// Enforces current slide centering when it's possible
	currentSlideCentering: false,
	// Enables strip-film mode (i.e. multiple slides on a line are visible on a time)
	stripfilm: false,
	// Enables swiping
	gestures: true
}

/**
 * Tape sliding effect mixin
 */
var BemCarouselTapeSlider = function(carousel) {
	this.carousel = carousel
	// Add new default options to carousel
	Object.keys(DEFAULTS).forEach(function(key) {
		if (!carousel.hasOwnProperty(key)) {
			carousel[key] = DEFAULTS[key]
		}
	})
}

BemCarouselTapeSlider.prototype = Object.create(BemCarouselSlider.prototype)

Object.assign(BemCarouselTapeSlider.prototype, {
	init: function() {
		if (this.carousel.gestures) {
			this.hammer = new Hammer(this.carousel.el)
			if (this.carousel.stripfilm) {
				this.hammer.on('panstart', this.onPanStart.bind(this))
				this.hammer.on('pancancel panend', this.onPanStop.bind(this))
				this.hammer.on('panmove', this.onPanMove.bind(this))
			} else {
				this.hammer.on('swipeleft', this.carousel.slide.bind(this.carousel, 1))
				this.hammer.on('swiperight', this.carousel.slide.bind(this.carousel, -1))
			}
		}
		$(window).resize(_.throttle(this.onWindowResize.bind(this), 200))
		return this
	},
	onPanStart: function(evt) {
		this.startingScrollLeft = this.getScrollLeft()
	},
	onPanStop: function(evt) {
		if (this.startingScrollLeft !== undefined) {
			if (evt.type == 'pancancel') {
				this.setScrollLeft(this.startingScrollLeft)
			}
			delete this.startingScrollLeft
			this.carousel.updateHasPrevNextModifiers()
		}
	},
	onPanMove: function(evt) {
		if (this.startingScrollLeft !== undefined) {
			this.setScrollLeft(this.startingScrollLeft - evt.deltaX)
			this.carousel.updateHasPrevNextModifiers()
		}
	},
	slideTo: function(index) {
		this.carousel.$el.queue(function() {
			if (index == this.carousel.currentSlideIndex) {
				this.carousel.$el.dequeue()
				return
			}

			this.carousel.beforeSlide(index)

			this.assignCurrentSlideClass(index)
			this.carousel.currentSlideIndex = index
			this.carousel.$currentSlide = this.carousel.$slides.eq(index)

			this.assignCurrentPillClass(index)
			this.updateTapePosition(true, function() {
				this.carousel.afterSlide(index)
				this.carousel.updateHasPrevNextModifiers()
			}.bind(this))

			this.carousel.$el.dequeue()
		}.bind(this))
	},
	updateTapePosition: function(animated, callback) {
		var $frame = this.carousel.$frame
		var enableScrolling = (
			$frame.css('overflow') == 'hidden' ||
			$frame.css('overflow-x') == 'hidden' ||
			$frame.css('overflow-y') == 'hidden'
		)
		if (!enableScrolling) {
			// Restore default (css-based) position
			this.carousel.$tape.css({'left': ''})
			return
		}
		// Whether to enforce slide centering
		var $slide = this.carousel.$slides.eq(this.carousel.currentSlideIndex)
		if (!this.carousel.currentSlideCentering && this.domCovers(this.carousel.$frame, $slide)) {
			// Do nothing, the slide is fully visible
			return
		}
		// Center the slide
		var frameCenterOffset = (this.carousel.$frame.width() - $slide.width()) / 2
		var slideParentOffset = $slide.position().left
		var maxOffset = -this.getMaxScrollLeft()
		// TODO: incorrect offset
		var marginLeft = 0
		if (this.carousel.currentSlideIndex > 0) {
			var $prevSlide = this.carousel.$slides.eq(this.carousel.currentSlideIndex - 1)
			var prevSlideRight = $prevSlide.offset().left + $prevSlide.outerWidth()
			marginLeft = $slide.offset().left - prevSlideRight
		}
		var offset = Math.max(Math.min(frameCenterOffset - slideParentOffset - marginLeft, 0), maxOffset)
		var css = {'left': offset}
		if (animated) {
			this.carousel.$tape.animate(css, this.carousel.slideDuration, this.carousel.slideEasing, callback)
		} else {
			this.carousel.$tape.css(css)
			if (callback) {
				callback()
			}
		}
	},
	/**
	 * Checks whether the `$cover` DOM element covers the `$within` DOM element.
	 */
	domCovers: function($cover, $within) {
		var cover = $cover.offset()
		var within =  $within.offset()
		return (
			cover.left <= within.left &&
			cover.top <= within.top &&
			cover.left + $cover.width() >= within.left + $within.outerWidth() &&
			cover.top + $cover.height() >= within.top + $within.outerHeight()
		)
	},
	onWindowResize: function() {
		this.updateTapePosition()
	},
	hasNext: function() {
		if (!this.carousel.stripfilm)
			return BemCarouselSlider.prototype.hasNext.call(this)
		return (this.getMaxScrollLeft() - this.getScrollLeft()) >= 1
	},
	hasPrev: function() {
		if (!this.carousel.stripfilm)
			return BemCarouselSlider.prototype.hasPrev.call(this)
		return this.getScrollLeft() > 0
	},
	setScrollLeft: function(value) {
		value = Math.max(Math.min(value, this.getMaxScrollLeft()), 0)
		this.carousel.$tape.css('left', -value + 'px')
	},
	getScrollLeft: function() {
		return -parseInt(this.carousel.$tape.css('left'))
	},
	getMaxScrollLeft: function() {
		return Math.max(this.carousel.totalWidth - this.carousel.$frame.width(), 0)
	}
})

module.exports = BemCarouselTapeSlider


/*****************
 ** WEBPACK FOOTER
 ** ./components/BemCarouselTapeSlider.js
 ** module id = 165
 ** module chunks = 0
 **/